import { render, staticRenderFns } from "./VeHrChangeTypeModal.vue?vue&type=template&id=0365cf9e"
import script from "./VeHrChangeTypeModal.vue?vue&type=script&lang=js"
export * from "./VeHrChangeTypeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports